/** UI language is German with real umlauts (.claude/rules/conventions.md). */
export const FIELD_STATE_LABELS = {
    locked: 'Noch geschlossen',
    today: 'Heute geöffnet',
    past_participated: 'Teilgenommen',
    past_open: 'Tag vorbei, Verlosung beendet',
    closed: 'Abgeschlossen',
    depublished: 'Derzeit nicht verfügbar',
};
/**
 * A textual marker per state. Colour alone must not carry meaning (9.6.5), so
 * every tile renders one of these next to the number.
 */
export const FIELD_STATE_MARKERS = {
    locked: '✕',
    today: '★',
    past_participated: '✓',
    past_open: '○',
    closed: '–',
    depublished: '!',
};
/**
 * Caption of a door inside this visitor's grace window. Short on purpose: it is printed on
 * the tile itself, and the notice read out with it says until when (9.6.1).
 */
export const GRACE_WINDOW_LABEL = 'Noch offen';
/**
 * The advertising notice, once per page (concept 9.3, invariant 2 as changed by D28). Every
 * door of the calendar is advertising, so a label on each door said nothing a single sentence
 * does not.
 */
export const SPONSORED_NOTICE = {
    door: 'Die Türchen dieses Kalenders enthalten Anzeigen unserer Partner.',
    field: 'Die Felder dieser Aktion enthalten Anzeigen unserer Partner.',
};
export const FIELD_TERM_LABELS = {
    door: { singular: 'Türchen', plural: 'Türchen' },
    field: { singular: 'Feld', plural: 'Felder' },
};
export function fieldTermSingular(term) {
    return FIELD_TERM_LABELS[term].singular;
}
export function fieldTermPlural(term) {
    return FIELD_TERM_LABELS[term].plural;
}
/**
 * Accessible name of a tile: "Türchen 7: Heute geöffnet. Teilnahme an der
 * Verlosung heute bis 23:59 Uhr". The visual children are hidden from the
 * accessibility tree so nothing is announced twice.
 */
export function fieldAccessibleName(options) {
    const base = `${fieldTermSingular(options.term)} ${options.position}: ${options.label}`;
    return options.noticeText ? `${base}. ${options.noticeText}` : `${base}.`;
}
//# sourceMappingURL=labels.js.map